export default {
    esgPlatform: {
      esgDashboard: "Painel ESG",
      esgPlatform: "Plataforma ESG",
      myProtocol: "Meu Programa ESG",
      esgProgress: "Progresso ESG",
      common: {
        myProducts: "Meus Produtos",
        esgCompliance: "Conformidade ESG",
        active: "Ativo",
        deactivated: "Desativado",
      },
  
      unit: "Unidade",
      mySurveys: "Minhas Pesquisas",
      copy: "Copiar",
      copySurvey: "Copiar Pesquisa",
      viewAssessmentQuestion: "Ver Pergunta de Avaliação",
      surveyTitlePlaceholder: "Título da Pesquisa",
      selectHeading: "Selecionar Título",
      headingDeleteConfirmationText: "Tem certeza de que deseja excluir este título?",
      questionDeleteConfirmationText: "Excluir esta pergunta removerá permanentemente todas as respostas enviadas pelos usuários em toda a empresa e sub-empresas. Isso também afetará o progresso ESG vinculado a esta pergunta. Esta ação não pode ser desfeita. Deseja continuar?",
      confirmDelete: "Confirmar",
      cancelDelete: "Cancelar",
      farmerSingleResponse: "Agricultor (Resposta única para todas as fazendas)",
      farmerSeparateResponse: "Agricultor (Resposta separada para cada fazenda)",
      fixedFrequency: "Frequência Fixa",
      custom: "Personalizado",
      day: "Dia",
      week: "Semana",
      month: "Mês",
      quarter: "Trimestre",
      year: "Ano",
      date: "Data",
      textField: "Campo de Texto",
      textArea: "Área de Texto",
      textFieldNumeric: "Campo de Texto Numérico",
      radioButton: "Botão de Rádio",
      checkBoxes: "Caixas de Seleção",
      getDataLabel: "Obter Dados",
      attachFiles: "Anexar Arquivos",
      digitalSignature: "Assinatura Digital",
      editSurvey: "Editar Pesquisa",
      editSurveyWarning: "Por favor, note que a pesquisa está atualmente ativa, e editar uma pergunta neste momento pode impactar envios anteriores. Para evitar problemas, você pode considerar criar uma cópia da pesquisa para fazer alterações nas perguntas.",
      clickToCreateCopy: "Clique Aqui Para Criar Cópia da Pesquisa",
      continueAndEdit: "Continuar e Editar",
      surveyBuilderEsg: "Construtor de Pesquisas",
      loadingAssessments: "Carregando avaliações...",
      noSurveysFound: "Nenhuma pesquisa encontrada",
      searchSurveysByTitle: "Pesquisar pesquisas pelo título...",
      editAssessmentQuestion: "Editar Pergunta de Avaliação",
      addAssessmentQuestion: "Adicionar Pergunta de Avaliação",
      score: "Pontuação",
      whoWillAnswerThisQuestion: "Quem responderá a esta pergunta?",
      whoWillAnswerTooltip: "Quem responderá esta pergunta.",
      questionType: "Tipo de Pergunta",
      typeOfQuestion: "Tipo de pergunta",
      titleTooltip: "Título da pergunta",
      enterHere: "Digite aqui",
      condition: "Condição",
      addDataField: "Adicionar Campo de Dados",
      dataField: "Campo de Dados",
      fileType: "Tipo de Arquivo",
      allowMultipleAttachments: "Permitir Múltiplos Anexos",
      allowComments: "Permitir Comentários",
      uploadSignatureFile: "Carregar Arquivo de Assinatura",
      drawSignature: "Desenhar Assinatura",
      description: "Descrição",
      descriptionTooltip: "Breve descrição da pergunta",
      addOption: "Adicionar Opção",
      addOptionTooltip: "Adicionar uma nova opção à lista",
      add: "Adicionar",
      pressEnterToAdd: "Pressione Enter para adicionar uma opção ou clique em Adicionar",
      options: "Opções",
      repeatPeriodically: "Repetir Periodicamente (Opcional)",
      repeatPeriodicallyTooltip: "Repetir Periodicamente (Opcional).",
      enabled: "Ativado",
      disabled: "Desativado",
      yes: "Sim",
      no: "Não",
      selectDate: "Selecionar Data",
      repetitionDates: "Datas de Repetição",
      repetitionDatesTooltip: "Datas em que a pergunta será repetida.",
      repeatsEvery: "Repete a cada",
      repetitions: "Repetições",
      selectStartDate: "Selecionar Data Inicial",
      cancel: "Cancelar",
      ok: "OK",
      submit: "Enviar",
      requireFileAttachment: "Exigir Anexo de Arquivo",
      standardSurvey: "Pesquisa Padrão",
      riskAssessmentSurvey: "Pesquisa de Avaliação de Risco",
      esgGoalSurvey: "Pesquisa de Meta ESG",
      rwaSurvey: "Pesquisa RWA",
      cannotGetAssessments: "Não é possível obter as avaliações",
      assessmentDeletedSuccessfully: "Avaliação excluída com sucesso",
      cannotDeleteAssessment: "Não é possível excluir a avaliação",
      errorDeletingAssessment: "Erro ao excluir a avaliação",
      goalProgress: "Progresso da Meta",
      selectSegment: "Selecionar Segmento",
      selectTopics: "Selecionar Tópicos",
      selectGoal: "Selecionar Meta",
      selectedGoal: "Meta Selecionada",
      searchSubOrganization: "Buscar Sub-organização",
      actions: "Ações",
      licenseId: "ID da Licença",
      exportAsCsv: "Exportar como CSV",
      registerUser: "Registar Utilizador(es)",
      enterpriseUsers: "Utilizadores da Empresa",
      singleUser: "Utilizador Único",
      multipleUser: "Múltiplos Utilizadores",
      selectStandard: "Selecionar Norma",
      sdgGoalsUpdated: "SDG Goals atualizados com sucesso",
      errorLoadingSDGGoals: "Erro ao carregar os SDG Goals",
      errorUpdatingSDGGoals: "Erro ao atualizar os SDG Goals",
      allSelectedSDGGoals: "Todos os SDG Goals selecionados",
      selectSDGGoals: "Selecionar SDG Goals",
      sdgGoals: "SDG Goals",
      country: "País",
      product: "Produto",
      clear: "Limpar",
      selectStandards: "Selecionar Normas",
      title: "Plataforma ESG",
      questionTitle: "Título da Pergunta",
      esgCompliance: "Conformidade ESG",
      standards: "Normas",
      addNewStandard: "Adicionar Nova Norma",
      surveyType: "Tipo de Pesquisa",
      addNewSurvey: "Adicionar Nova Pesquisa",
      surveyDescription: "Descrição da Pesquisa",
      surveyDescriptionTT: "Digite a descrição da pesquisa",
      surveyInstructions: "Instruções da Pesquisa",
      surveyInstructionsTT: "Digite as instruções da pesquisa",
      surveyScore: "Pontuação da Pesquisa",
      surveyScoreTT: "Permitir pontuação da pesquisa",
      whoWillAnswerThisSurvey: "Quem Vai Responder Esta Pesquisa?",
      whoWillAnswerThisSurveyTT: "Selecione o tipo de usuários que responderão esta pesquisa",
      typeOfTheSurvey: "Tipo da Pesquisa",
      standardTitle: "Título da Norma",
      standardTitleTT: "Digite o título da norma",
      shortCode: "Código Curto",
      shortCodeTT: "Digite o código curto da norma",
      standardDescription: "Descrição da Norma",
      standardDescriptionTT: "Digite a descrição da norma",
      seal: "Selo",
      sealTT: "Selecione o selo da norma",
      status: "Status",
      upload: "Carregar",
      thisfieldIsRequired: "Este campo é obrigatório",
      pleaseFillRequiredFields: "Preencha os campos obrigatórios",
      standardAddedSuccessfully: "Norma adicionada com sucesso",
      errorSubmittingForm: "Erro ao enviar o formulário",
      createNewEsgStandard: "Criar Nova Norma ESG",
      close: "Fechar",
      settings: "Configurações",
      next: "Próximo",
      keyIssuesAndGoals: "Tópicos-Chave e Metas",
      keyIssuesAndGoalsTT: "Tópicos-chave e metas da norma",
      environmental: "Ambiental",
      issues: "Tópicos",
      addIssue: "Adicionar Tópico",
      social: "Social",
      governance: "Governança",
      goals: "Metas",
      target: "Meta (Anos)",
      questions: "Perguntas",
      type: "Tipo",
      mandatory: "Obrigatório",
      addNewGoal: "Adicionar Nova Meta",
      deleteIssueConfirmation:
        "Tem certeza de que deseja excluir este tópico? A exclusão também removerá permanentemente todas as metas e perguntas associadas. Esta ação não pode ser desfeita.",
      deleteGoalConfirmation:
        "Tem certeza de que deseja excluir esta meta? A exclusão também removerá permanentemente todas as perguntas associadas. Esta ação não pode ser desfeita.",
      deleteConfirmation:
        "Tem certeza de que deseja excluir? Esta ação não pode ser desfeita.",
      standardSettings: "Configurações da Norma",
      standardStatus: "Status da Norma",
      active: "Ativo",
      inactive: "Inativo",
      approvalMethod: "Método de Aprovação",
      approveManually: "Aprovar Manualmente",
      scoreForApproval: "Pontuação para Aprovação",
      overallProtocolScore: "Pontuação Geral do Programa",
      overallProtocolScoreTT: "Insira a pontuação geral do programa",
      heading: "Cabeçalho",
      selectHeadingTooltip: "Selecione um cabeçalho para a pergunta da pesquisa",
      survey: "Pesquisa",
      goalTitle: "Título da Meta",
      goalTitleTT: "Digite o título da meta",
      goalTargetYear: "Ano-Alvo da Meta",
      environmetalScore: "Pontuação Ambiental",
      environmetalScoreTT: "Digite a pontuação ambiental",
      socialScore: "Pontuação Social",
      socialScoreTT: "Digite a pontuação social",
      governanceScore: "Pontuação de Governança",
      governanceScoreTT: "Digite a pontuação de governança",
      mandatoryApproval: "Aprovação Obrigatória",
      preview: "Pré-visualizar",
      pleaseAddAtLeastOneIssueAndGoal:
        "Adicione pelo menos um tópico com ao menos uma meta antes de prosseguir para a pré-visualização.",
      noContentToPreview:
        "Não há conteúdo para pré-visualizar. Adicione pelo menos um tópico e uma meta.",
      standardPreview: "Pré-visualização da Norma",
      saveStandard: "Salvar Norma",
      standardSavedSuccessfully: "Norma salva com sucesso!",
      standardDeletedSuccessfully: "Norma excluída com sucesso!",
      protocolDeletedSuccessfully: "Programa excluído com sucesso!",
      standardUpdatedSuccessfully: "Norma atualizada com sucesso!",
      pleaseEnterWholeNumberBetween0and100:
        "Digite uma porcentagem entre 0 e 100",
      issueCreatedSuccessfully: "Tópico criado com sucesso",
      errorCreatingIssue: "Erro ao criar tópico. Tente novamente.",
      issueTitleUpdatedSuccessfully: "Título do tópico atualizado com sucesso",
      errorUpdatingIssueTitle: "Erro ao atualizar o título do tópico. Tente novamente.",
      issueDeletedSuccessfully: "Tópico excluído com sucesso",
      errorDeletingIssue: "Erro ao excluir tópico. Tente novamente.",
      goalCreatedSuccessfully: "Meta criada com sucesso",
      errorCreatingGoal: "Erro ao criar meta. Tente novamente.",
      goalUpdatedSuccessfully: "Meta atualizada com sucesso",
      errorUpdatingGoal: "Erro ao atualizar o título da meta. Tente novamente.",
      errorDeletingGoal: "Erro ao excluir meta. Tente novamente.",
      goalDeletedSuccessfully: "Meta excluída com sucesso",
      standardActivatedSuccessfully: "Norma ativada com sucesso",
      goalTitleRequired: "O título da meta é obrigatório",
      questionsRequired: "As perguntas são obrigatórias",
      noSurveyAvailable: "Nenhuma pesquisa disponível",
      myProducts: {
        addNewProduct: "Adicionar Novo Produto",
        lastUpdated: "Última Atualização",
        addedBy: "Adicionado Por",
      },
      dashboard: {
        subEnterprises: "Subempresas",
        registerSubEnterprise: "Registrar Subempresa",
        exportAsCSV: "Exportar como CSV",
        enterprise: "Empresa",
        licenseID: "ID da Licença",
        membershipPlan: "Plano de Associação",
        activationKeys: "Chaves de Ativação",
        users: "Usuários",
        registrationDate: "Data de Registro",
        country: "País",
        status: "Status",
  
        countryPlaceholder: "Selecione o país",
        enterpriseName: "Nome da Empresa",
        enterpriseNamePlaceholder: "Digite o nome da empresa",
        enterpriseEmail: "E-mail da Empresa",
        enterpriseEmailPlaceholder: "Digite o e-mail da empresa",
        enterprisePhoneNumber: "Telefone da Empresa",
        enterprisePhoneNumberPlaceholder: "Digite o número de telefone",
        provincePlaceholder: "Digite a província/estado",
        regionPlaceholder: "Digite a região/distrito",
        villagePlaceholder: "Digite vila/cidade",
        address: "Endereço",
        province: "Província/Estado",
        region: "Região/Distrito",
        village: "Vila/Cidade",
        addressPlaceholder: "Digite o endereço",
        dateOfRegistration: "Data de Registro",
        dateOfRegistrationPlaceholder: "Selecione a data de registro",
        subscriptionUpTo: "Assinatura Até",
        subscriptionUpToPlaceholder: "Selecione a data de término da assinatura",
        products: "Produtos",
        initialAssessmentReport: "Relatório de Avaliação Inicial",
        enterHere: "Digite Aqui",
        attachInitialAssessmentReport: "Anexar Relatório de Avaliação Inicial",
        linkWithProducts: "Vincular com Produtos",
        linkWithProductsPlaceholder: "Selecione produtos vinculados",
        uploadLogo: "Carregar Logotipo",
        uploadLogoPlaceholder: "Carregar logotipo da empresa",
        licenseIDPlaceholder: "Digite o ID da Licença",
  
        deactivateAccount: "Desativar Conta",
        activateAccount: "Ativar Conta",
        deactivateMsg: "Tem certeza de que deseja desativar esta conta?",
        activateMsg: "Tem certeza de que deseja ativar esta conta?",
        deleteAccount: "Excluir Conta",
        deleteMsg: "Tem certeza de que deseja remover esta conta?",
      },
  
      activate: "Ativar",
      confirmation: "Confirmação",
      standardDeleteConfirmation:
        "Tem certeza de que deseja excluir esta norma?",
      protocolDeleteConfirmation:
        "Tem certeza de que deseja excluir este programa?",
      surveyQuestionForTheGoal: "Pergunta da Pesquisa para a Meta",
      selectExistingESGSurveyOrCreateNew:
        "Selecione uma pesquisa ESG existente ou crie nova",
      surveyBuilder: "Construtor de Pesquisa ESG",
      surveyDetails: "Detalhes da Pesquisa",
      createnewSurvey: "Criar nova pesquisa",
      startContinueSurvey: "Iniciar/Continuar Pesquisa",
      surveyOverview: "Visão Geral da Pesquisa",
      surveyOverviewPage: {
        goalDetails: "Detalhes da Meta",
        totalQuestions: "Total de Perguntas",
        targetYear: "Ano-Alvo",
        showOnlyRepeatSubmissions: "Mostrar Apenas Submissões Repetidas",
        noQuestionsFound: "Nenhuma pergunta encontrada para os filtros selecionados.",
        fallbackCategory: "Categoria {number}",
      },
      surveyTitle: "Título da Pesquisa",
      surveyTitleTT: "Digite o título da pesquisa",
      surveyCompletionPercentage: "Porcentagem de Conclusão da Pesquisa",
      submitted: "Enviado",
      rejected: "Rejeitado",
      pending: "Pendente",
      approved: "Aprovado",
      completed: "Concluído",
      notStarted: "Não Iniciado",
      inProgress: "Em Andamento",
      surveyProgress: "Progresso da Pesquisa",
      howToCompleteSurvey: "Como Concluir a Pesquisa",
      confirmSurveyResponse:
        "Você está prestes a enviar sua resposta. Confirme se deseja prosseguir.",
        progress: {
            progress: "Progresso",
            dashboard: "Painel",
            esgProgress: "Progresso ESG",
            companyName: "Nome da Empresa",
            search: "Pesquisar",
            select: "Selecionar",
            country: "País",
            standard: "Norma",
            subOrganization: "Suborganização",
            protocols: "Protocolos",
            actions: "Ações",
            subOrganizations: "Suborganizações",
            downloadReport: "Baixar Relatório",
            comparison: "Comparação",
            messages: "Mensagens",
            validateData: "Validar Dados",
            recommendations: "Recomendações",
            ESRSIssueAndGoals: "Tópicos e Metas ESRS",
            protocolProgress: "progresso geral",
          },
          validation: {
            dataValidations: "Validações de Dados",
            validateData: "Validar Dados",
            inputData: "Inserir Dados",
            question: "Pergunta",
            issueAndGoal: "Tópico e Meta",
            environmental: "Ambiental",
            social: "Social",
            governance: "Governança",
            search: "Pesquisar",
            select: "Selecionar",
            answer: "Resposta",
            farm: "Fazenda",
            farmLocation: "Localização da Fazenda",
            farmGeofence: "Geocerca da Fazenda",
            viewQuestionResponse: "Ver Resposta da Pergunta",
            viewResponse: "Ver Resposta",
            showOnMap: "Mostrar no mapa",
            noModuleDataAvailable: "Nenhum dado do módulo disponível",
            noData: "Nenhum dado",
            noSelection: "Nenhuma seleção",
            noAnswer: "Nenhuma resposta",
            noTitle: "Sem título",
            noResponse: "Nenhuma resposta",
            noMeasurement: "Nenhuma medição",
            noFile: "Nenhum arquivo",
            viewSignature: "Ver Assinatura",
            noSignature: "Nenhuma assinatura",
            unknownType: "Tipo desconhecido",
            unknownOption: "Desconhecido",
            unnamedFile: "Arquivo sem nome",
            dimitraModule: "Módulo Dimitra",
            download: "Baixar",
            comments: "Comentários",
            currentStatus: "Status Atual",
            updatedBy: "Atualizado Por",
            statusUpdateHistory: "Histórico de Atualização de Status",
            noHistoryYet: "Ainda não há histórico.",
            finalStatus: "Status Final",
            approveAction: "Aprovar",
            rejectAction: "Rejeitar",
            reasonRequired: "Selecione um status e adicione comentários.",
            approvalSuccess: "Resposta aprovada com sucesso.",
            approvalFailed: "Falha ao aprovar a resposta. Tente novamente.",
            rejectionSuccess: "Motivo da rejeição enviado com sucesso.",
            rejectionFailed: "Falha ao enviar motivo da rejeição. Tente novamente.",
          },
          startNewEsgProtocol: "Iniciar Novo Programa ESG",
          getStartedWithEsg: "Começar com ESG",
          getStartedEsgMsg:
            "Nenhum Programa foi adicionado ainda. Adicione um Programa para iniciar sua jornada em direção a uma gestão e relatórios ESG eficazes.",
          startEsgProtocol: "Iniciar Programa ESG",
          createNewProtocolWithoutStandard: "Criar novo Programa sem norma",
          selectEsgStandard: "Selecionar Norma ESG",
          addNewProtocol: "Adicionar Novo Programa",
          protocolTitle: "Título do Programa",
          subOrganization: "Suborganizações",
          protocolAddedMsg: "Programa adicionado com sucesso.",
          existingProtocols: "Programas Existentes",
          protocolSettings: "Configurações do Programa",
          protocolSettingsUpdated: "Configurações do Programa atualizadas com sucesso.",
          failedToUploadFile: "Falha ao enviar imagem. Tente novamente.",
          failedToUploadFileToS3: "Falha ao enviar imagem para o S3",
          selectSubOrg: "Selecionar Suborganizações",
          selectSubOrgMsg:
            "Selecione a suborganização para a qual você está definindo metas e objetivos relacionados aos protocolos ESG (Ambiental, Social e Governança). Esta opção permite especificar qual parte da sua organização é responsável por implementar e acompanhar esses objetivos. Ao atribuir metas às suborganizações individuais, você pode personalizar as iniciativas ESG para atender necessidades e impactos operacionais específicos, garantindo uma abordagem focada em sustentabilidade e governança nos diferentes níveis da organização.",
          selectedSubOrg: "Suborganizações Selecionadas",
          subOrgs: "Suborganizações",
          activityLog: "Registro de Atividades",
          activityLogFor: "Registro de Atividades Para",
          activityLogDesc:
            "Acompanhe todas as alterações feitas nas metas, perguntas e tópicos ESG, incluindo adições, edições e exclusões, com detalhes do usuário, ação e data/hora",
          protocolActivatedSuccessfully: "Programa ativado com sucesso",
          activationKey: "Chave de Ativação",
          userNameAndId: "Nome e ID do Usuário",
          email: "E-mail",
          userRole: "Função do Usuário",
          userRegistrationDate: "Data de Registro do Usuário",
          protocolUpdatedSuccessfully: "Programa atualizado com sucesso.",
          createNewProtocol: "Criar novo Programa",
          myProtocols: "Meu Programa ESG",
          viewDetails: "Ver Detalhes",
          viewProgressByGoal: "Ver Progresso por Meta",
          downloadReport: "Baixar Relatório",
          chooseTimeFrame: "Escolha o período do relatório que deseja baixar.",
          downloading: "Baixando",
          downloadingDesc: "Seu relatório do Programa ESG está sendo preparado para download. Aguarde enquanto geramos o arquivo.",
          updateStatus: "Atualizar Status",
          updateStatusDesc: "Selecione o novo status do Programa Abrafrutas/Produtores de Frutas para a suborganização AGRICULTURA DO VALE LTDA - AGRIVALE.",
          validationConfirm: "Confirmação",
          validationConfirmMsg: "Tem certeza de que deseja rejeitar esta resposta? O usuário precisará enviar novamente. Esta ação não pode ser desfeita.",
          validationRejectionReason: "Motivo da Rejeição",
          validationRejectionReasonPlaceholder: "Digite aqui",
          inputData: "Inserir Dados",
          question: "Pergunta",
          issueGoal: "Tópico e Meta",
          surveyResponseText: "Resposta da Pesquisa",
          goal: "Meta",
          submittedOn: "Enviado em",
          submittedBy: "Enviado Por",
          dateSubmitted: "Data de Envio",
          responses: "Respostas",
          uploadedDocument: "Documento Enviado",
          noFilesUploaded: "Nenhum arquivo enviado",
          getData: "Obter Dados",
          recommendations: "Recomendações",
          enterYourRecommendations: "Digite suas recomendações",
          actionPlan: "Plano de Ação",
          subOrganizations: "Suborganizações",
          farms: "Fazendas",
          farmers: "Produtores",
          totalGoals: "Total de Metas",
          startDate: "Data de Início",
          deadline: "Prazo",
          standard: "Norma",
          goalsProgress: "Progresso das Metas",
          esrsProtocol: "Programa ESRS",
          company: "Empresa",
      
          surveyResponse: {
            enterYourAnswer: "Digite sua resposta",
            fieldRequired: "Este campo é obrigatório",
            additionalQuestions: "Perguntas Adicionais",
            previous: "ANTERIOR",
            skip: "PULAR",
            submit: "ENVIAR",
            submitAgain: "ENVIAR NOVAMENTE",
            submissionRejected: "Sua submissão foi rejeitada",
            rejectionReason: "Motivo",
            submissionRehectedMsg: "A submissão foi rejeitada",
            next: "PRÓXIMO",
            step: "Etapa",
            of: "de",
            question: "Pergunta",
            errorLoadingStandard: "Erro ao carregar a norma",
            errorLoadingQuestions: "Erro ao carregar as perguntas",
            errorSubmittingSurvey: "Erro ao enviar a pesquisa",
            surveySubmittedSuccess: "Pesquisa enviada com sucesso",
            loadingGoalTitle: "Carregando título da meta...",
            questionOf: "Pergunta {current} de {total}",
            ratingScale: {
              title: "Use a Escala de Avaliação",
              description:
                "Para perguntas que utilizam escala de avaliação (por exemplo, 1 a 5), considere o seguinte:",
              stronglyDisagree: "1 = Discordo Totalmente",
              disagree: "2 = Discordo",
              neutral: "3 = Neutro",
              agree: "4 = Concordo",
              stronglyAgree: "5 = Concordo Totalmente",
              chooseNumber: "Escolha o número que melhor reflete sua opinião.",
            },
            instructions: {
              readCarefully: "Leia Cada Pergunta com Atenção",
              readDescription:
                "Reserve um tempo para entender cada pergunta antes de selecionar sua resposta. A pesquisa inclui perguntas de múltipla escolha, escala de avaliação e abertas.",
              beHonest: "Seja Honesto e Transparente",
              beHonestDescription:
                "Suas respostas nos ajudarão a avaliar nossas práticas atuais e identificar áreas de melhoria. Por favor, forneça um feedback honesto com base em suas experiências.",
              provideExamples: "Forneça Exemplos Específicos",
              provideExamplesDescription:
                "Nas perguntas abertas, sinta-se à vontade para incluir exemplos ou sugestões. Seu feedback detalhado será fundamental para aprimorar nossas iniciativas ESG.",
              reviewResponses: "Revise Suas Respostas",
              reviewResponsesDescription:
                "Antes de enviar, reserve um momento para revisar suas respostas. Certifique-se de que está satisfeito e que todas as perguntas foram respondidas.",
              submitSurvey: "Enviar a Pesquisa",
              submitSurveyDescription:
                "Quando estiver confiante em suas respostas, clique no botão 'Enviar' no final da pesquisa. Sua participação é muito importante!",
              contactSupport: "Contate-nos para Suporte",
              contactSupportDescription:
                "Se tiver dúvidas ao preencher a pesquisa, entre em contato com nossa equipe de suporte pelo [e-mail de suporte] ou [telefone de suporte].",
            },
            actionPlans: "Planos de Ação",
            uploadEvidence: "Carregar Evidência",
            fileUploadSuccess: "Arquivo enviado com sucesso",
            fileUploadError: "Erro ao enviar o arquivo",
            addSignature: "Adicionar Assinatura",
            comments: "Comentários",
            selectMeasurementUnit: "Selecionar Unidade de Medida",
            unitType: "Tipo de Unidade",
            unit: "Unidade",
            selectFile: "Selecione o arquivo para enviar os dados",
            dragDrop: "ou arraste e solte aqui",
            farmOf: "Fazenda {current} de {total}",
            repeatSubmission: "Submissão Repetida",
            submissionOf: "Submissão: {current} de {total}",
            responseRejected: "Resposta Rejeitada",
            notYetSubmitted: "Ainda não enviado",
            notSubmitted: "Não enviado",
            upcoming: "Em breve",
            recommendations: "Recomendações",
            selectedOptionNotFound: "Opção selecionada não encontrada",
            signatureRequired: "Assinatura obrigatória",
            waitForFileUpload: "Aguarde o envio do arquivo",
            fileRequired: "Arquivo obrigatório",
            getDataQuestions: "Obter Perguntas de Dados",
            noResponsesToSubmit: "Nenhuma resposta para enviar",
            surveyCompletedSuccess: "Pesquisa concluída com sucesso",
          },
      
          validateData: "Validar Dados",
          messages: "Mensagens",
          comparision: "Comparação",
          download: "Baixar",
          issueAndGoal: "Tópico e Meta",
          reasonForRejection: "Motivo da Rejeição",
          listOfUsers: "Lista de Usuários",
          totalUsers: "Total de Usuários",
          viewQuestionsRecommendations: "Ver Recomendações das Perguntas",
          protocolDetails: "Detalhes do Programa",
          select: "Selecionar",
          selectDimitraApp: "Selecionar aplicação Dimitra",
          selectModule: "Selecionar módulo",
          dimitraModuleDataFields: "Campos de dados do módulo Dimitra",
          selection: "Seleção",
          selectModuleToViewDataFields: "Selecione um módulo para ver os campos de dados.",
          retrieveData: "Recuperar dados",
          noDataFieldsAvailable: "Nenhum campo de dados disponível para este módulo.",
          progressMetricRules: "Regras de métrica de progresso",
          metricTitle: "Título",
          enterTitle: "Inserir título",
          module: "Módulo",
          datafield: "Campo de dados",
          addAnotherModule: "Adicionar outro módulo",
          formulaPreview: "Pré-visualização:",
          conditions: "Condições",
          if: "Se",
          addNewCondition: "Adicionar nova condição",
          addProgressMetric: "Adicionar métrica de progresso",
          yearOnYearComparisonScore: "Pontuação de comparação ano a ano",
          selectProgressMetric: "Selecionar métrica de progresso",
          dimitraModules: "Módulos Dimitra",
          dimitraModuleCatalog: {
            modules: {
              Irrigation: "Irrigação",
              Harvesting: "Colheita",
              Soil: "Gestão do Solo",
              Farms: "Fazendas",
            },
            fields: {
              "date-of-entry": "Data de Entrada",
              irrigation_farm: "ID da Fazenda",
              farmId: "ID da Fazenda",
              farmName: "Nome da Fazenda",
              "farm-name": "Nome da Fazenda",
              registrationNo: "ID de Registo da Fazenda",
              farmerName: "Nome do Agricultor",
              farmOwnershipType: "Tipo de Propriedade da Fazenda",
              farmCertifications: "Certificações da Fazenda",
              location: "Localização",
              address: "Endereço de Localização",
              country: "País",
              state: "Província/Estado",
              city: "Aldeia/Cidade",
              farmNumber: "Número da Fazenda",
              farmGeofence: "Geofence da Fazenda",
              deforestationStatus: "Estado de Desflorestamento",
              area: "Área",
              irrigation_cropType: "Tipo de Cultura",
              harvest_cropType: "Tipo de Cultura",
              cropType: "Tipo de Cultura",
              irrigation_cropVariety: "Variedade de Cultura",
              harvesting_variety: "Variedade de Cultura",
              waterSource: "Fonte de Água",
              irrigation_waterSource: "Água Superficial",
              irrigatedArea: "Área Irrigada",
              irrigation_dates: "Data(s) de Irrigação",
              irrigation_stage: "Fase de Irrigação",
              irrigation_schedule: "Irrigação/Cronograma",
              totalDays: "Número Total de Dias",
              irrigation_type: "Tipo de Irrigação",
              waterVolumeUsed: "Volume de Água Utilizado",
              totalNumberOfWorkers: "Número Total de Trabalhadores",
              totalNumberOfHours: "Número Total de Horas",
              totalCost: "Custo Total",
              "area-planted": "Área Plantada",
              "start_date_harvesting": "Data de Início da Colheita",
              "end_date_harvesting": "Data de Fim da Colheita",
              "daysHarvesting": "Número Total de Dias",
              "totalFreshYield": "Rendimento Fresco Total",
              "totalDryYield": "Rendimento Seco Total",
              "total_planned_fresh_yield": "Rendimento Fresco Planeado Total",
              "total_planned_dry_yield": "Rendimento Seco Planeado Total",
              "yieldForHouseholdConsumption": "Rendimento para Consumo Doméstico",
              "yieldForSale": "Rendimento para Venda",
              "method_for_harvesting": "Método de Colheita",
              "soilType": "Tipo de Solo",
              "soilHealth": "Estado de Saúde do Solo",
              "soilPh": "pH do Solo",
              "soilNutrientContent": "Conteúdo de Nutrientes do Solo",
              "nitrogen": "Nitrogênio",
              "phosphorus": "Fósforo",
              "potassium": "Potássio",
              "sulfur": "Enxofre",
              "calcium": "Cálcio",
              "magnesium": "Magnésio",
              "iron": "Ferro",
              "zinc": "Zinco",
              "boron": "Boro",
              "fertilizerInputs": "Insumos de Fertilizante",
              "fertilizerName": "Nome do Fertilizante",
              "fertilizerType": "Tipo de Fertilizante",
              "fertilizerCost": "Custo do Fertilizante",
              "applicationRate": "Taxa de Aplicação",
              "applicationMethod": "Método de Aplicação",
              "ingredientName": "Nome do Ingrediente",
              "ingredientPercentage": "Porcentagem",
              "ingredientQuantity": "Quantidade do Ingrediente",
              "ingredientCost": "Custo do Ingrediente",
            },
          },
          esgReport: {
            esgReportBuilder: "Construtor de Relatório ESG",
            manageTemplates: "Gerenciar Modelos",
            createNewEsgReport: "Criar Novo Relatório ESG",
            listOfReports: "Lista de Relatórios",
            reportId: "ID do Relatório",
            template: "Modelo",
            access: "Acesso",
            dateGenerated: "Data de Geração",
            status: "Status",
            fileUploadFailed: "Falha no carregamento do ficheiro",
            unsupportedFileFormat: "Formato de ficheiro não suportado",
            errorUploadingFile: "Erro ao carregar o ficheiro",
            view: "Ver",
            edit: "Editar",
            download: "Descarregar",
            copyAndCreateNew: "Copiar e Criar Novo",
            delete: "Eliminar",
            esgReportTemplates: "Modelos de Relatórios ESG",
            back: "Voltar",
            createNewTemplate: "Criar Novo Modelo",
            listOfTemplates: "Lista de Modelos",
            esgPlatform: "Plataforma ESG",
            reportBuilder: "Construtor de Relatórios",
            createTemplate: "Criar Modelo",
            preview: "Pré-visualizar",
            tooltipCreateTemplate: "Adicionar novo modelo",
            tooltipPreview: "Pré-visualizar e guardar o seu modelo",
            deleteEsgReport: "Eliminar Relatório ESG",
            confirmDeleteReportMessage: "Tem a certeza de que deseja eliminar este relatório?",
            cancel: "Cancelar",
            nameOfTemplate: "Nome do Modelo",
            next: "Seguinte",
            previewReport: "Pré-visualizar Relatório",
            reportPreviewMessage: "É aqui que a pré-visualização do relatório será exibida.",
            save: "Guardar",
            confirmationTitle: "Confirmação",
            confirmationMessage: "Tem a certeza de que deseja guardar as suas alterações?",
            confirm: "CONFIRMAR",
            createEsgTemplate: "Criar Modelo ESG",
            section: "Secção",
            addBlock: "Adicionar Bloco",
            addNew: "Adicionar Novo",
            customSections: "Secções Personalizáveis",
            databaseDrivenSections: "Secções Baseadas em Base de Dados",
            submit: "Enviar",
            heading: "Cabeçalho",
            paragraph: "Parágrafo",
            image: "Imagem",
            stakeholders: "Partes Interessadas",
            table: "Tabela",
            esgProgressLineChart: "Gráfico de Linha de Progresso ESG",
            esgScorecard: "Ficha de Avaliação ESG",
            backgroundColor: "Cor de Fundo",
            fontColor: "Cor da Fonte",
            font: "Fonte",
            pdfHeader: "Cabeçalho do PDF",
            reportHeaderLogo: "Logótipo do Cabeçalho do Relatório",
            uploadLogo: "Carregar Logótipo",
            addImage: "Adicionar Imagem",
            pleaseWait: "Aguarde",
            defaultLogo: "Logótipo Padrão",
            scorecardSectionImages: "Imagens das Secções do Scorecard",
            scorecardSectionImagesHint: "Carregue imagens de cabeçalho personalizadas para as secções Ambiental, Social e Governação. Se deixado em branco, são usadas as imagens predefinidas.",
            sectionSettings: "Definições da Secção",
            selectSectionTimeline: "Selecionar Linha Temporal da Secção",
            lockSectionForSubOrganization: "Bloquear Secção para Sub-Organização",
            sectionTimelineHint: "Esta linha temporal aplica-se apenas a esta secção",
            sectionLockedHint: "Se bloqueado, esta seção não poderá ser modificada pelas sub-organizações.",
            createEsgReport: "Criar Relatório ESG",
            close: "Fechar",
            templateSettings: "Configurações do Modelo",
            reportTypeSelection: "Seleção do Tipo de Relatório",
            reportTimeline: "Linha do Tempo do Relatório",
            selectTimeline: "Selecionar Linha do Tempo",
            templateName: "Nome do Modelo",
            addNewSection: "Adicionar Nova Seção",
            previewPlaceholder: "Aqui será exibida a pré-visualização do relatório.",
            finish: "Concluir",
            editEsgReport: "Editar Relatório ESG",
            saveChanges: "Salvar Alterações",
            esgReport: "Relatório ESG",
            downloadReport: "Baixar Relatório",
            downloadAsPdf: "Baixar como PDF",
            downloadAsPdfNoImages: "Baixar como PDF (sem imagens)",
            breadcrumbEsgPlatform: "Plataforma ESG",
            breadcrumbReportBuilder: "Construtor de Relatórios",
            breadcrumbCreateReport: "Criar Relatório",
            stepReportDetails: "Detalhes do Relatório",
            stepReportDetailsTooltip: "Configure os detalhes e as configurações do relatório",
            stepCustomizeReport: "Personalizar Relatório",
            stepCustomizeReportTooltip: "Adicione seções e personalize o conteúdo",
            stepPreview: "Pré-visualização",
            stepPreviewTooltip: "Pré-visualize e publique seu relatório",
            publicReport: "Relatório Público",
            internalReport: "Relatório Interno",
            confirmText: "CONFIRMAR",
            cancelText: "CANCELAR",
            closeConfirmTitle: "Confirmar Fechamento",
            closeConfirmMessage: "Tem certeza de que deseja fechar o relatório? Seu progresso será salvo e o status será definido como 'Salvo'. Você poderá retomar a edição depois.",
            selectEsgProgram: "Selecionar Programa ESG",
            noProtocolDetails: "Nenhum detalhe disponível para o protocolo selecionado.",
            overallProgress: "Progresso Geral",
            environmentalProgress: "Progresso Ambiental",
            socialProgress: "Progresso Social",
            governanceProgress: "Progresso de Governança",
            subOrganization: "Sub-organização",
            environmental: "Ambiental",
            social: "Social",
            governance: "Governança",
            actions: "Ações",
            name: "Nome",
            type: "Tipo",
            selectTemplate: "Selecionar um Modelo",
            createNew: "Criar Novo",
            startNow: "Começar Agora",
            select: "Selecionar",
            esgProgressLineGraph: "Gráfico de Linha de Progresso ESG",
            selectEsgComponents: "Selecione os componentes ESG para mostrar no gráfico:",
            componentSettings: "Configurações do Componente",
            enterSectionTitle: "Insira o título da seção",
            colorBlue: "Azul",
            colorWhite: "Branco",
            colorPrimaryGreen: "Verde Primário",
            colorDarkGreen: "Verde Escuro",
            colorBlack: "Preto",
            colorGrey: "Cinza",
            colorCustom: "Personalizado...",
            headingSize: "Tamanho do Título",
            headingTitle: "Texto do Título",
            overview: "Visão Geral",
            selectImageType: "Selecionar Tipo de Imagem",
            singleImage: "Imagem Única",
            imageGrid: "Grade de Imagens",
            gridSize: "Tamanho da Grade",
            imageSize: "Tamanho da Imagem",
            imageSizeHint: "Reduza a largura da imagem se for demasiado grande e empurrar conteúdo para a página seguinte.",
            images: "Imagens",
            stakeholder: "Parte Interessada",
            message: "Mensagem",
            addNewStakeholder: "Adicionar Nova Parte Interessada",
            enterMessageHere: "Digite a mensagem aqui",
            noOfColumns: "Nº de Colunas",
            noOfRows: "Nº de Linhas",
            column: "Coluna",
            columnName: "Nome da Coluna",
            gridOfReports: "Grade de Relatórios",
            noReportFound: "Nenhum relatório encontrado",
            tableSettings: "Configurações da Tabela",
            tableHeaderBg: "Cor de Fundo do Cabeçalho da Tabela",
            tablebg: "Cor de Fundo da Tabela",
            editTemplate: "Editar Modelo",
            copy: "Copiar",
            myTemplates: "Meus Modelos",
            organizationTemplates: "Modelos da Organização",
            myTemplatesHint: "Ligado: mostra apenas os modelos criados pela sua sub-organização. Desligado: mostra os modelos da sua organização, que pode copiar.",
            ownedByYou: "Seu modelo",
            ownedByOrganization: "Modelo da organização",
            organizationTemplateReadOnlyHint: "Este modelo pertence à sua organização e é somente leitura. Use \"Botão de Copiar \" para criar a sua própria cópia editável — o original permanecerá inalterado.",
            templateCopyCreatedTitle: "Nova Cópia de Modelo Criada",
            templateCopiedMessage: "Foi criada uma cópia \"{name}\" para a sua sub-organização. Já pode editá-la.",
            templateForkedOnEditMessage: "Porque editou o modelo da organização, foi criada uma nova cópia \"{name}\" para a sua sub-organização e este relatório está agora ligado a essa cópia. O modelo original da organização permanece inalterado.",
            templateCopyFailed: "Não foi possível copiar o modelo. Tente novamente.",
            templateRelinkFailed: "Não foi possível ligar este relatório à sua cópia do modelo, por isso nada foi guardado. O modelo original da organização permanece inalterado. Tente novamente.",
            templatesLoadFailed: "Não foi possível carregar os modelos. Tente novamente.",
            templateLoadFailed: "Não foi possível carregar o modelo. Tente novamente."
          },
          newestFirst: 'Mais Recente Primeiro',
          oldestFirst: 'Mais Antigo Primeiro',
          sort: 'Ordenar',
          assessmentFarmer: {
            // Partilhado entre páginas de detalhe
            viewOnMap: "Ver no Mapa",
            polygon: "Polígono",
            point: "Ponto",
            farmGeofence: "Geocerca da Fazenda",
            farmGeofenceLabel: "Geocerca da fazenda",
            location: "Localização",
            reportDate: "Data do Relatório",
            overallDeforestationProbability: "Probabilidade Geral de Desmatamento",
            deforestationStatus: "Estado de Desmatamento",
            viewReport: "Ver Relatório",
            noDetailsAvailable: "Nenhum detalhe disponível.",
            moreDetailsAvailable: "+{count} mais detalhes disponíveis",
            // Shared across pages
            responses: "Respostas",
            company: "Empresa",
            submittedBy: "Enviado Por",
            dateSubmitted: "Data de Envio",
            submittedOn: "Enviado em",
            questionsPrefix: "Perguntas",
            farm: "Fazenda",
            additionalInformationGetData: "Informações Adicionais (Obter Dados)",
            carbonFallback: "Carbono",
            soilManagementFallback: "Gestão do Solo",
            module: "Módulo",
            details: "Detalhes",
            farmDetails: "Detalhes da Fazenda",
            farmGeofencing: "Geocerca da Fazenda",
            noResponsesFound: "Nenhuma resposta encontrada para esta avaliação.",
            litersLabel: "{value} Litros",
            acresLabel: "{value} Acres",
            waterSource: "Fonte de Água",
            irrigatedArea: "Área Irrigada",
            irrigationStage: "Estágio de Irrigação",
            cropType: "Tipo de Cultura",
            cropVariety: "Variedade da Cultura",
            irrigationSchedule: "Cronograma de Irrigação",
            irrigationType: "Tipo de Irrigação",
            totalDays: "Total de Dias",
            totalWorkers: "Total de Trabalhadores",
            totalHours: "Total de Horas",
            totalCost: "Custo Total",
            areaPlanted: "Área Plantada",
            startDateOfHarvesting: "Data de Início da Colheita",
            endDateOfHarvesting: "Data de Término da Colheita",
            totalNumberOfDays: "Número Total de Dias",
            totalFreshYield: "Rendimento Total de Frescos",
            totalDryYield: "Rendimento Total de Secos",
            totalPlannedFreshYield: "Rendimento Total Planejado de Frescos",
            totalPlannedDryYield: "Rendimento Total Planejado de Secos",
            yieldForHouseholdConsumption: "Rendimento para Consumo Doméstico",
            yieldForSale: "Rendimento para Venda",
            methodOfHarvesting: "Método de Colheita",
            // DimitraDetails
            farmLocation: "Localização da Fazenda",
            totalArea: "Área Total",
            acres: "Acres",
            noDimitraFarmDetails: "Nenhum detalhe de fazenda Dimitra encontrado para este registo.",
            noDimitraDetailsNotification: "Nenhum detalhe Dimitra encontrado para esta seleção.",
            // IrrigationDetails
            irrigationDetails: "Detalhes de Irrigação",
            trackingContributions: "Acompanhando as suas contribuições para a sustentabilidade.",
            irrigationCount: "Contagem de Irrigação",
            totalWaterVolumeUsed: "Volume Total de Água Utilizado",
            liters: "Litros",
            irrigationCountDetails: "Detalhes da Contagem de Irrigação",
            noIrrigationDetails: "Nenhum detalhe de irrigação encontrado para este registo.",
            noIrrigationDetailsNotification: "Nenhum detalhe de irrigação encontrado para esta seleção.",
            // Questions
            showResponses: "Mostrar Respostas",
            total: "Total",
            targetYear: "Ano-Alvo",
            missingRouteParams: "Parâmetros obrigatórios em falta para a navegação.",
            // Responses
            dimitraModule: "Módulo Dimitra",
            actionPlans: "Planos de Ação",
            uploadedFiles: "Ficheiros Carregados",
            noResponse: "Sem Resposta",
            repeatSubmission: "Submissão Repetida",
            responseRejected: "Resposta Rejeitada",
            upcoming: "Em breve",
            notYetSubmitted: "Ainda não enviado",
            notSubmitted: "Não enviado",
            errorLoadingSurveyResponses: "Erro ao carregar respostas do questionário",
          },
          selectRespondents: "Selecionar Respondentes",
          supplierServiceType: "Tipo de Serviço do Fornecedor",
          selectSupplierServiceTypeTT: "Selecione o Tipo de Serviço do Fornecedor.",
          selectServiceType: "Selecionar Tipo de Serviço",

          // SelectSurveyUsers
          selectSurveyUsers: "Selecionar Utilizadores do Questionário",
          pleaseSelectUsersToProceed: "Por favor selecione utilizador(es) para continuar",
          userSelected: "Utilizador Selecionado",
          usersSelected: "Utilizadores Selecionados",
          conditional: "Condicional",
          filterBy: "Filtrar Por",
          loadingUsers: "A carregar utilizadores...",
          searchUsers: "Pesquisar Utilizadores",
          selectAllUsers: "Selecionar Todos os Utilizadores",
          autoConditions: "Condições Automáticas",
          membershipType: "Tipo de Associação",
          memberRole: "Função do Membro",
          gender: "Género",
          registrationDate: "Data de Registo",
          startDateLabel: "Data de Início",
          endDateLabel: "Data de Fim",
          conditionStatus: "Estado da Condição",
          conditionDescription: "Os utilizadores que correspondam às condições tornar-se-ão automaticamente elegíveis para este questionário.",
          clearAll: "Limpar Tudo",
          save: "Guardar",
          all: "Todos",
          deactivated: "Desativado",
          continue: "Continuar",
          membershipTypeDefault: "Padrão",
          farmer: "Agricultor",
          technician: "Técnico",
          factoryBuyingStation: "Fábrica / Estação de Compra",
          coffeeFarmer: "Agricultor de Café",
          cacaoFarmer: "Agricultor de Cacau",
          male: "Masculino",
          female: "Feminino",
          other: "Outro",
          userName: "Nome do Utilizador",
          failedToLoadSurveyUsers: "Falha ao carregar utilizadores do questionário",

          // SelectCooperatives
          selectSubOrganizations: "Selecionar Sub-organizações",
          pleaseSelectSubOrgsToProceed: "Por favor selecione Sub-organizações para continuar",
          subOrganizationSelected: "Sub-organização Selecionada",
          subOrganizationsSelected: "Sub-organizações Selecionadas",
          loadingSubOrganizations: "A carregar Sub-organizações...",
          searchSubOrganizations: "Pesquisar Sub-organizações",
          selectAllSubOrganizations: "Selecionar Todas as Sub-organizações",
          cooperative: "Cooperativa",
          membershipPlan: "Plano de Associação",
          membershipValidity: "Validade da Associação",
          failedToLoadSubOrganizations: "Falha ao carregar Sub-organizações",

          // CreateSurvey
          surveyStatus: "Estado do Questionário",
          typeOfSurvey: "Tipo de Questionário",
          pleaseSelectTargetYear: "Por favor selecione um ano alvo",
          yearMustBeInFuture: "O ano deve ser no futuro",
          headingUpdated: "Cabeçalho atualizado: {title}",
          headingCreatedSuccess: "Cabeçalho criado com sucesso: {title}",
          headingDeletedSuccess: "Cabeçalho eliminado com sucesso: {id}",
          headingUpdatedSuccess: "Cabeçalho atualizado com sucesso: {order}",
          questionUpdatedSuccess: "Pergunta atualizada com sucesso: {order}",
          assessmentNotFoundForId: "Avaliação não encontrada para o id",
          errorFetchingAssessmentDetails: "Erro ao obter detalhes da avaliação",
          surveyDuplicatedSuccessfully: "Questionário duplicado com sucesso",
          failedToDuplicateSurvey: "Falha ao duplicar questionário. Por favor tente novamente.",
          somethingWentWrongDuplicating: "Algo correu mal ao duplicar o questionário.",
          basicSurveySettings: "Configurações Básicas do Questionário",
          advancedSurveySettings: "Configurações Avançadas do Questionário",
          moduleIntegration: "Integração de Módulo",
          questionFeatures: "Funcionalidades das Perguntas",
          surveyTitleFieldTT: "Título do questionário",
          describeHere: "Descreva aqui",
          activationStatusOfSurvey: "Estado de ativação do questionário",
          scheduleEnabledLabel: "Agendamento Ativado",
          selectStartEndDates: "Selecione datas de início e fim para este questionário",
          endDate: "Data de Fim",
          attachSurveyToModule: "Associar Questionário ao Módulo",
          selectDimitraModuleTT: "Selecione o módulo Dimitra ao qual este questionário pertence",
          selectPostAnswerActions: "Selecionar Ações Pós-resposta",
          actionsAfterAnswerTT: "Ações disponíveis após uma resposta ser selecionada",
          repeatQuestionFunctionality: "Funcionalidade de Pergunta Repetida",
          enableRepeatedQuestionsTT: "Ativar perguntas repetidas para este questionário",
          selectQuestionTypesLabel: "Selecionar Tipos de Pergunta",
          questionTypesAvailableTT: "Tipos de perguntas disponíveis ao construir este questionário",
          chooseDate: "Escolher Data",
          selectedDate: "Data Selecionada",
          selectBtn: "SELECIONAR",
          standardLabel: "Padrão",
          startDateRequired: "A Data de Início é obrigatória",
          endDateRequired: "A Data de Fim é obrigatória",
          endDateBeforeStartDate: "A Data de Fim não pode ser anterior à Data de Início",
          noModuleOptionsAvailable: "Nenhuma opção de módulo disponível",
          selectedAnswererNotAvailable: "O respondente selecionado não está disponível para o módulo selecionado",
          updatedSurveySuccess: "Questionário atualizado com sucesso!",
          createdSurveySuccess: "Questionário criado com sucesso!",
          errorSavingAssessment: "Erro ao guardar avaliação",

          // SurveyList
          sortSurveysByDate: "Ordenar questionários por mais recente ou mais antigo",
          view: "Ver",
          delete: "Eliminar",

          // General
          loading: "A carregar",

          // File types
          fileTypeImage: "Imagem (JPEG, GIF, PNG)",
          fileTypeVideo: "Vídeo (mp4)",
          fileTypeDocx: "DOCX",
          fileTypePdf: "PDF",

          // SurveyQuestion notifications
          unableToFetchAssessmentQuestion: "Não foi possível obter a pergunta de avaliação.",
          validationError: "Erro de Validação",
          pleaseSelectHeadingBeforeSubmitting: "Por favor selecione um cabeçalho antes de enviar.",
          questionSubmittedSuccessfully: "Pergunta enviada com sucesso",
          errorSubmittingAssessmentQuestion: "Erro ao enviar pergunta de avaliação",
          optionAdded: "Opção Adicionada",
          optionAddedSuccess: "Opção adicionada com sucesso!",
          failedToAddOption: "Falha ao adicionar opção.",
          actionPlanCreatedSuccess: "Plano de ação criado com sucesso!",
          failedToCreateActionPlan: "Falha ao criar plano de ação.",
          actionPlanUpdatedSuccess: "Plano de ação atualizado com sucesso!",
          failedToUpdateActionPlan: "Falha ao atualizar plano de ação.",
          dataFieldDeletedSuccess: "Campo de dados eliminado com sucesso!",
          failedToDeleteDataField: "Falha ao eliminar campo de dados.",
          error: "Erro",
        },
      };
